import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import AuthShell from "@/pages/auth/AuthShell";
import { useI18n } from "@/context/I18nContext";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { toast } from "sonner";

export default function Register() {
  const { t } = useI18n();
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", confirm: "", country: "", phone: "", agree: false });
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (form.password !== form.confirm) { setErr(t("auth.mismatch")); return; }
    if (!form.agree) { setErr("Please agree to the Terms."); return; }
    setLoading(true);
    try {
      await register({ name: form.name, email: form.email, password: form.password, country: form.country, phone: form.phone, agree: form.agree });
      toast.success("Account created! Welcome to ADNEXA DIGITAL.");
      nav("/dashboard");
    } catch (e2) { const m = apiError(e2); setErr(m); toast.error(m); }
    setLoading(false);
  };

  return (
    <AuthShell title={t("auth.registerTitle")} subtitle={t("auth.registerSub")}
      footer={<>{t("auth.haveAccount")} <Link to="/login" className="text-amber-400 font-semibold" data-testid="to-login-link">{t("auth.signin")}</Link></>}>
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        {err && <div className="rounded-lg bg-red-500/10 border border-red-500/30 text-red-300 text-sm px-4 py-3" data-testid="register-error">{err}</div>}
        <div><label className="label-lux">{t("auth.name")}</label><input required className="input-lux mt-2" value={form.name} onChange={set("name")} data-testid="register-name-input" /></div>
        <div><label className="label-lux">{t("auth.email")}</label><input required type="email" className="input-lux mt-2" value={form.email} onChange={set("email")} data-testid="register-email-input" /></div>
        <div className="grid grid-cols-2 gap-3">
          <div><label className="label-lux">{t("auth.password")}</label><input required type="password" className="input-lux mt-2" value={form.password} onChange={set("password")} data-testid="register-password-input" /></div>
          <div><label className="label-lux">{t("auth.confirm")}</label><input required type="password" className="input-lux mt-2" value={form.confirm} onChange={set("confirm")} data-testid="register-confirm-input" /></div>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div><label className="label-lux">{t("auth.country")}</label><input className="input-lux mt-2" value={form.country} onChange={set("country")} data-testid="register-country-input" /></div>
          <div><label className="label-lux">{t("auth.phone")}</label><input className="input-lux mt-2" value={form.phone} onChange={set("phone")} data-testid="register-phone-input" /></div>
        </div>
        <label className="flex items-start gap-2.5 text-sm text-slate-400 cursor-pointer">
          <input type="checkbox" checked={form.agree} onChange={set("agree")} className="mt-1 accent-amber-500" data-testid="register-agree-checkbox" />
          <span>{t("auth.agree")}</span>
        </label>
        <button disabled={loading} className="gold-btn w-full" data-testid="register-submit-btn">{loading ? <Loader2 className="animate-spin" size={18} /> : t("auth.signup")}</button>
      </form>
    </AuthShell>
  );
}
